import { Clear, CloudUpload } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import shadows from '@mui/material/styles/shadows';
import { useState } from 'react';
import Dropzone from 'react-dropzone';
import styled from 'styled-components';
import { Body, Child, Container, StyledButton, Title } from '../../components';
import { darkBlue } from '../../models/colors';
import { DataSharingAgreementFormService } from '../../services';
import { home } from '../../text';

export const AdminDashboard = () => {
	const [file, setFile] = useState<File[]>([]);
	const [isUploaded, setIsUploaded] = useState<string>('No file to upload.');

	return (
		<Container container>
			<Child item>
				<Title>{home.adminDashboard.title}</Title>
			</Child>
			<Child container item>
				<Child item>
					<Body>{home.adminDashboard.body}</Body>
				</Child>
				<Child container item>
					<StyledButton
						onClick={() =>
							DataSharingAgreementFormService.getReport().then(response => {
								const url = window.URL.createObjectURL(new Blob([response.data]));
								const link = document.createElement('a');
								link.href = url;
								const contentDisposition = response.headers['content-disposition'];
								let fileName = 'report.csv';
								if (contentDisposition) {
									const fileNameMatch = contentDisposition.match(
										/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
									);
									if (fileNameMatch?.length && fileNameMatch.length >= 2) {
										fileName = fileNameMatch[1].replace(/['"]+/g, '');
									}
								}
								link.setAttribute('download', fileName);
								link.click();
								window.URL.revokeObjectURL(url);
							})
						}
					>
						DOWNLOAD REPORT
					</StyledButton>
				</Child>
			</Child>
			<Child container item style={{ marginTop: '72px' }}>
				<Child item>
					<Body>{home.adminDashboard.body2}</Body>
				</Child>
				<Child container item direction="column" alignItems="center" style={{ width: '352px' }}>
					<Dropzone onDrop={acceptedFiles => setFile(acceptedFiles)}>
						{({ getRootProps, getInputProps }) => (
							<Upload>
								<div {...getRootProps()}>
									<input {...getInputProps()} accept="application/pdf" />
									<InnerUpload>
										<CloudUpload style={{ marginRight: '24px' }} />
										<span>
											Drag or click here to upload your new Data Sharing Agreement Template
										</span>
									</InnerUpload>
								</div>
							</Upload>
						)}
					</Dropzone>
					<FileArea>
						{file.length > 0 ? (
							file.map(f => (
								<IndividualFile key={f.lastModified}>
									<FileName>{f.name}</FileName>
									<IconButton
										onClick={() => {
											setFile([]);
											setIsUploaded('');
										}}
									>
										<Clear />
									</IconButton>
								</IndividualFile>
							))
							) : null
						}
						{file.length > 0 ? (
							<StyledButton
								fullWidth
								onClick={(e: any) => {
									e.preventDefault();
									DataSharingAgreementFormService.newFormTemplate(file[0]).then(r =>
										r.status === 200
											? setIsUploaded(`File uploaded successfully.`)
											: setIsUploaded(`File failed to upload.`)
									);
								}}
							>
								UPLOAD
							</StyledButton>
							) : null
						}
					</FileArea>
					<Child item>
						<Body>{isUploaded}</Body>
					</Child>
				</Child>
			</Child>
		</Container>
	);
};

const Upload = styled('div')`
  padding: 24px;
  cursor: pointer;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: ${shadows[1]};
  transition: 200ms ease-in-out;
  &:hover {
    background-color: #eee;
  }
  & > * + & > * {
    margin-top: 24px;
  }
`;
const InnerUpload = styled('div')`
  display: flex;
  align-items: center;
`;
const FileName = styled('div')`
  width: 100%;
  word-break: break-all;
  padding: 8px 8px 8px 16px;
  font-family: 'Roboto', sans-serif;
`;
const FileArea = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;
const IndividualFile = styled('div')`
  width: 100%;
  padding: 8px;
  display: flex;
  margin: 16px 0;
  flex-wrap: nowrap;
  border-radius: 4px;
  color: ${darkBlue};
  align-items: center;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: ${shadows[1]};
`;
